import React, { useState, useEffect } from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import { adviseNewImage } from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import AdviseMeRightPanel from "./AdviseMeRightPanel";
import AdviseMeSidePic from "@assets/images/AdviseMeSidePic.svg";
import AdviseMeButton from "./AdviseMeButton";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditableInput from "./EditableInput";
import SelectField from "./SelectField";
import ExercisePreferences from "./ExercisePreferences";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";

const AdviseMeAuto = ({
  setOpen,
  isAdviceLoading,
  countdown,
  message,
  autoSeletctedTags,
  getFieldValue,
  handleInputChange,
  handleSelectChange,
  handleMultiSelectChange,
  timelineOptions,
  durationTypeOptions,
  daysOptions,
  exerciseTimeOptions,
  getDynamicDropdownOptions,
  getDisplayName,
  handleWeightUnitChange,
  getDisplayMap,
  handleApplyGoal,
  autoSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className="AdviseMeAuto bg-cover text-white relative rounded-[12px] my-7 pb-5"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      {/* Right Column - Professional Advice */}
      {/* {message ? (
        <>
          <h1 className="text-[20px] text-white font-[600] font-[Lato] mb-3 md:mb-9 pt-6 px-6">
            Our Professional Advice For You
          </h1>
          <div className="flex justify-center">
            <AdviseMeButton
              setOpen={setOpen}
              isAdviceLoading={isAdviceLoading}
              countdown={countdown}
              t={t}
              width="40%"
            />
          </div>
          <AdviseMeRightPanel
            message={message}
            AdviseMeSidePic={AdviseMeSidePic}
            t={t}
          />
        </>
      ) :  */}

      <div className="grid xl:grid-cols-7">
        <div className="col-span-3 p-6">
          <h1 className="text-[20px] text-white font-[600] font-[Lato] m-0">
            Our Professional Advice For You
          </h1>
          <div className="font-[Lato] my-7">
            <p>Receive tailored guidance based on your fitness goals.</p>
            <ul className="list-disc pl-5">
              <li>Personalized insights</li>
              <li>Instant generation</li>
              <li>Goal-focused guidance</li>
            </ul>
          </div>
          <AdviseMeButton
            setOpen={setOpen}
            isAdviceLoading={isAdviceLoading}
            countdown={countdown}
            t={t}
          />
        </div>
        <div className="col-span-4 flex justify-end">
          <img src={adviseNewImage} alt="image" className="object-contain" />
        </div>
      </div>
      {autoSeletctedTags && (
        <>
        <div className="flex justify-center mx-4 rounded-xl bg-white">
          <div className="w-full">
            {/* Left Column - Input Fields */}
            <div className="p-4">
              {/* Input Fields Grid */}
              <div
                className="grid grid-cols-1 md:grid-cols-2 gap-4"
                // style={{ pointerEvents: "none" }}
              >
                <div style={{ pointerEvents: "none" }}>
                  <h2 className="text-[20px] font-[Lato] font-[600] mb-4">Advised Preferences</h2>
                  <div>
                    <EditableInput
                      field="targetWeight"
                      label={t(`firstFormSteps.targetWeight.label`)}
                      value={getFieldValue("targetWeight")}
                      targetWeightUnit={getFieldValue("targetWeightUnit")}
                      onChange={handleInputChange}
                      onWeightUnitChange={handleWeightUnitChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <EditableInput
                      field="goalBodyFat"
                      label={t("Goal Body Fat")}
                      unit="%"
                      value={getFieldValue("goalBodyFat")}
                      onChange={handleInputChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <EditableInput
                      field="goalWaistCircumference"
                      label={t("Goal Waist Circumference")}
                      unit="cm"
                      value={getFieldValue("goalWaistCircumference")}
                      onChange={handleInputChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <EditableInput
                      field="maintenanceCalories"
                      label={t(`firstFormSteps.maintenanceCalories.label`)}
                      value={getFieldValue("maintenanceCalories")}
                      onChange={handleInputChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <EditableInput
                      field="targetDailyCalories"
                      label={t(`firstFormSteps.targetDailyCalories.label`)}
                      value={getFieldValue("targetDailyCalories")}
                      onChange={handleInputChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <EditableInput
                      field="dailyCalorieAdjustment"
                      label={t(`preferences.fields.dailyCalorieAdjustment`)}
                      unit="Kcal"
                      isReadOnly={true}
                      value={getFieldValue("dailyCalorieAdjustment")}
                      onChange={handleInputChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <EditableInput
                      field="goalSteps"
                      label={t(`preferences.fields.goalSteps`)}
                      value={getFieldValue("goalSteps")}
                      onChange={handleInputChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <EditableInput
                      field="targetActiveTime"
                      label={t(`preferences.fields.targetActiveTime`)}
                      value={getFieldValue("targetActiveTime")}
                      onChange={handleInputChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <SelectField
                      field="timeline"
                      label={t(`firstFormSteps.timeline.label`)}
                      options={timelineOptions}
                      value={getFieldValue("timeline")}
                      onChange={handleSelectChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>

                  <div>
                    <SelectField
                      field="durationType"
                      label={t(`firstFormSteps.durationType.label`)}
                      options={durationTypeOptions}
                      value={getFieldValue("durationType")}
                      onChange={handleSelectChange}
                      // errors={errors}
                      isAdviceLoading={true}
                      t={t}
                    />
                  </div>
                </div>
                <AdviseMeRightPanel
                  message={message}
                  AdviseMeSidePic={AdviseMeSidePic}
                  t={t}
                />
              </div>

              {/* Exercise Preferences Section */}
              {/* <div className="mt-6 border border-gray-200 rounded-lg bg-white p-4"> */}
              <ExercisePreferences
                getFieldValue={getFieldValue}
                getDynamicDropdownOptions={getDynamicDropdownOptions}
                handleMultiSelectChange={handleMultiSelectChange}
                handleSelectChange={handleSelectChange}
                getDisplayName={getDisplayName}
                getDisplayMap={getDisplayMap}
                errors={{}}
                isAdviceLoading={isAdviceLoading}
                daysOptions={daysOptions}
                exerciseTimeOptions={exerciseTimeOptions}
                t={t}
                disabled={true}
              />
          <button
            type="button"
            onClick={() => handleApplyGoal(true)}
            disabled={isAdviceLoading || autoSubmit}
            className={`mt-6 px-4 py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-md w-full min-h-[46px] ${
              (isAdviceLoading || autoSubmit) && "opacity-70"
            }`}
          >
            {autoSubmit ? (
              <ButtonLoader />
            ) : (
              t("firstFormSteps.navigationButtons.submit")
            )}
          </button>
            </div>
          </div>

        </div>
        </>
      )}
    </div>
  );
};

export default AdviseMeAuto;
